module.exports = __webpack_public_path__ + "static/dev-tool-4a61171024c1e1985abfac2bebc7dbee.png";